import requestOTP from './requestOTP'
import verifyOTP from './verifyOTP'
import applyForPrivilege from './applyForPrivilege'

export default {
  requestOTP,
  verifyOTP,
  applyForPrivilege,
}
